import Swiper, {Navigation, Pagination, Scrollbar, Thumbs, Autoplay, Lazy} from 'swiper';
Swiper.use([Navigation, Pagination, Scrollbar, Thumbs, Autoplay, Lazy]);


export default class SwipersObj{
    constructor() { 

        if(document.getElementsByClassName('object_block')){

            let blocks = document.querySelectorAll(".object_block");

            let num = 0;
            blocks.forEach((block)=>{
                const swiper1 = block.querySelector(".obj_swiper_off");
                const swiper2 = block.querySelector(".obj_swiper_main");

                if (!swiper1 || !swiper2) {
                    // console.log('');
                    return;
                }
                const swiper = new Swiper('#'+swiper1.getAttribute('id'), {
                    loop: true,
                    spaceBetween: 10,
                    slidesPerView: 4,
                    freeMode: true,
                    watchSlidesProgress: true,
                });
                const swiper_ = new Swiper('#'+swiper2.getAttribute('id'), {
                    loop: true,
                    spaceBetween: 10,
                    slidesPerView: 1,
                    navigation: {
                      nextEl: ".production_photo_swiper_next_"+num,
                      prevEl: ".production_photo_swiper_prev_"+num
                    },
                    thumbs: {
                      swiper: swiper,
                    },
                });
                num++;
            })
            
        }
          
    }
}